module.exports = __webpack_public_path__ + "img/message-slash.ff8661ca.svg";